<template>
  <div class="shop">
    <div class="container is-boxed-fluid">
      <div class="products">
        <div class="row">
          <div class="col-2 col-md-12">
            <div class="sidebar" v-show="!page.loading || filters">
              <div class="shop-mobile-filters toggle-item" :class="{active: active_sidebar}" @click="active_sidebar=!active_sidebar" v-show="['xs', 'sm', 'ms'].includes($mq)"><span></span>{{$t('refine_items')}}</div>
              <div class="filters-list" v-show="['md', 'lg', 'xl', 'hd', 'inf'].includes($mq) || active_sidebar">
                <component
                        :is="filter.component"
                        v-for="(filter, key_1) in filters"
                        :key="filter.id"
                        :filter="filter"
                ></component>
                <component
                        :is="filter.component"
                        @set_query="set_query"
                        v-for="(filter, key_2) in page_filters"
                        :key="filter.id"
                        :filter="filter"
                ></component>
                <component :is="'reset'" :title="'ՀԵՌԱՑՆԵԼ ՖԻԼՏՐԵՐԸ'"></component>
              </div>
            </div>
            <div class="load-sidebar" v-show="['md', 'lg', 'xl', 'hd', 'inf'].includes($mq) && page.loading && !filters">
              <ul>
                <li class="loading"></li>
                <li class="loading"></li>
                <li class="loading"></li>
                <li class="loading"></li>
                <li class="loading"></li>
                <li class="loading"></li>
                <li class="loading"></li>
                <li class="loading"></li>
                <li class="loading"></li>
                <li class="loading"></li>
              </ul>
            </div>
          </div>

          <div class="col-10 col-md-12">
            <div class="page-headline">
              <div class="row ns between">
                <div class="col-8 col-xs-12">
                  <p class="shop-description">{{page.data.description}}</p>
                </div>
                <div class="col col-xs-12">
                  <div class="sort-products">
                    <span>{{sort_by.name}}</span>
                    <div>
                      <ul>
                        <li v-for="(item, key) in sorting" :key="key" @click="sort_by=item">{{item.name}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="products-not-found" v-show="!page.loading && page.data.products.length==0">
              {{$t('not_found')}}
              <div>
                <router-link :to="{name: 'shop'}" class="reset-filters">{{$t('reset_filters')}}</router-link>
              </div>
            </div>
            <div class="row fade" id="products" :class="{'gut-1': $mq=='xs' || $mq=='sm' || $mq=='ms'}" v-show="!page.loading">
              <div class="col-4 col-md-6 col-xs-12" v-for="(product, key) in shopProducts" :key="key">
                <product :item="product"></product>
              </div>
            </div>
            <div class="row fade load-products" :class="{'gut-1': $mq=='xs' || $mq=='sm' || $mq=='ms'}" v-show="page.loading">
              <div class="col-4 col-xs-6">
                <div class="loading"></div>
              </div>
              <div class="col-4 col-xs-6">
                <div class="loading"></div>
              </div>
              <div class="col-4 col-xs-6">
                <div class="loading"></div>
              </div>
              <div class="col-4 col-xs-6">
                <div class="loading"></div>
              </div>
              <div class="col-4 col-xs-6">
                <div class="loading"></div>
              </div>
              <div class="col-4 col-xs-6">
                <div class="loading"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Product from '@/components/items/Product.vue';
import Categories from '@/components/shop/filters/Categories.vue';
import Price from '@/components/shop/filters/Price.vue';
import Color from '@/components/shop/filters/Color.vue';
import Size from '@/components/shop/filters/Size.vue';
import Listing from '@/components/shop/filters/Listing.vue';
import Reset from '@/components/shop/filters/Reset.vue';
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  components: {
    Product,
    Categories,
    Price,
    Listing,
    Color,
    Size,
    Reset
  },
  i18n: {
    messages: {
      en: {
        not_found: 'PRODUCTS NOT FOUND',
        reset_filters: 'RESET FILTERS'
      },
      hy: {
        not_found: 'ԱՊՐԱՆՔՆԵՐ ՉԵՆ ԳՏՆՎԵԼ',
        reset_filters: 'ՀԵՌԱՑՆԵԼ ՖԻԼՏՐԵՐԸ'
      }
    }
  },
  data () {
    return {
      active_sorting: 'New Arrivals',
      active_sidebar: false,
      sort_by: {
        name: 'New Arrivals',
        sort: 'id',
        order: 'asc'
      },
      sorting: [
        {
          name: 'New Arrivals',
          sort: 'id'
        },
        {
          name: 'Price: Low to High',
          sort: 'price',
          order: 'asc'
        },
        {
          name: 'Price: High to low',
          sort: 'price',
          order: 'desc'
        }
      ],
      filters: false,
      page_filters: []
    }
  },
  methods: {
    set_query (option, filter_name) {
      let query = {}
      for (var key in this.page.data.page_filters) {
        let selected_options = []
        for (var i in this.page.data.page_filters[key].options) {
          if (this.page.data.page_filters[key].options[i].selected) {
            selected_options.push(
              this.page.data.page_filters[key].options[i].id
            )
          }
        }
        if (selected_options.length > 0) {
          query[this.page.data.page_filters[key].name] = selected_options.join(
            ','
          )
        }
      }
      if (filter_name == 'price') {
        query[filter_name] = option
      }

      this.$router.replace({
        name: 'shop',
        params: {
          taxonomy: this.$route.params.taxonomy,
          term: this.$route.params.term
        },
        query: query
      })
    }
  },
  watch: {
    'page.data.filters' (to, from) {
      this.filters = this.page.data.filters
      this.page_filters = this.page.data.page_filters
    }
  },
  beforeMount () {
    this.$store.dispatch('fetchPage', {
      products: [],
      breadcrumbs: []
    })
  },
  computed: {
    ...mapState([
      'page'
    ]),
    shopProducts: function () {
      return _.orderBy(this.page.data.products, this.sort_by.sort, this.sort_by.order)
    }
  }
}
</script>

<style lang="scss">
.shop {
  padding-top: 130px;
  padding-bottom: 120px;

  @include mq($md) {
    padding-top: 65px;
    padding-bottom: 0;
  }

  .page-headline {
    position: relative;
    z-index: 10;

    .sort-products {
      height: 40px;
      font-size: 16px;
      border: 1px solid #1e1e1e;
      width: 260px;
      overflow: hidden;

      span {
        display: block;
        line-height: 40px;
        padding: 0 15px;
        position: relative;
        &:after {
          content: "";
          position: absolute;
          width: 10px;
          height: 10px;
          border-left: 1px solid #1e1e1e;
          border-bottom: 1px solid #1e1e1e;
          right: 15px;
          top: -5px;
          bottom: 0;
          margin: auto;
          transform: rotate(-45deg);
        }
      }

      &:hover {
        overflow: visible;
        span {
          &:after {
            bottom: -5px;
            border: 0;
            border-right: 1px solid #1e1e1e;
            border-top: 1px solid #1e1e1e;
          }
        }
      }

      & > div {
        padding-top: 10px;
        ul {
          box-shadow: 0px 2px 6px #0000001a;
          background: #ffffff;
          li {
            line-height: 40px;
            padding: 0 10px;
            cursor: pointer;
            &:hover {
              background: #eff0f0;
            }
          }
        }
      }
    }

    .shop-description{
      font-size: 16px;
      margin: 0;
      @include mq($ms){
        margin-bottom: 15px;
      }
    }
  }

  .sidebar {
    animation: fade 1.5s 0s forwards;
  }

  .load-sidebar {
    animation: fade 1s forwards;
    opacity: 0;
    ul {
      li {
        height: 20px;
        margin-bottom: 15px;
        animation: gradient 0.7s infinite;

        &:nth-child(1) {
          width: 60%;
        }
        &:nth-child(2) {
          width: 75%;
        }
        &:nth-child(3) {
          width: 70%;
        }
        &:nth-child(4) {
          width: 65%;
        }
        &:nth-child(5) {
          width: 95%;
        }
        &:nth-child(6) {
          width: 73%;
        }
        &:nth-child(7) {
          width: 45%;
        }
        &:nth-child(8) {
          width: 70%;
        }
        &:nth-child(9) {
          width: 50%;
        }
        &:nth-child(10) {
          width: 100%;
        }
      }
    }
  }

  .load-products {
    .col-4,
    .col-3 {
      div {
        min-height: 600px;
        animation: gradient 0.7s infinite;

        @include mq($ms){
          min-height: 200px;
        }
      }
    }
  }

  .products {
    .products-not-found {
      padding: 30px;
      text-transform: uppercase;
      text-align: center;
      max-width: 500px;
      box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.12);
      margin: auto;
      margin-top: 100px;

      @include mq($ms){
        margin-top: 15px;
        margin-bottom: 15px;
      }

      a {
        padding-top: 15px;
        font-size: 14px;
        color: #a09a9a;
        display: inline-block;
      }
    }
    .with-line {
      padding-top: 0;
      &:before {
        display: none;
      }
    }
  }
}
</style>
